/**
 * ZP Autonomous Analytics Module
 * Self-executing module for GTM.
 */
(function () {
  const initAnalytics = () => {
    window.dataLayer = window.dataLayer || [];

    // 1. Precise Navigation Tracking (Header & Footer)
    document.addEventListener("click", (e) => {
      const link = e.target.closest("a, button");
      if (!link) return;

      // Check for your specific classes
      const isHeaderLink =
        link.classList.contains("header__link") ||
        link.closest(".header__link");
      const isFooterLink = link.closest(".footer__links");
      const isHeroBtn = link.closest(".hero__actions .btn");

      let eventName = "navigation_click";
      let location = "";

      if (isHeaderLink) location = "header_main_menu";
      if (isFooterLink) location = "footer_links";

      if (isHeroBtn) {
        eventName = "cta_click";
        location = "hero_section";
      }

      if (location) {
        window.dataLayer.push({
          event: eventName,
          nav_location: location,
          link_text: link.innerText.trim() || "Icon/Image Click",
          link_url: link.href || "#",
        });
      }
    });

    // 2. Track Contact Form 7 Success
    document.addEventListener(
      "wpcf7mailsent",
      (event) => {
        window.dataLayer.push({
          event: "form_submit_success",
          form_id: event.detail.contactFormId,
          page_location: window.location.href,
        });
      },
      false,
    );

    // 3. Track First Interaction with Form
    const contactForm = document.querySelector(".wpcf7-form");
    if (contactForm) {
      contactForm.addEventListener(
        "focusin",
        () => {
          window.dataLayer.push({
            event: "form_interaction_start",
            action: "user_started_filling_form",
          });
        },
        { once: true },
      );
    }

    // 4. Precise Scroll Tracking
    let scrollMarkers = [25, 50, 75, 90];
    let sentMarkers = [];

    window.addEventListener(
      "scroll",
      () => {
        const scrollPercent = Math.round(
          ((window.scrollY + window.innerHeight) /
            document.documentElement.scrollHeight) *
            100,
        );

        scrollMarkers.forEach((marker) => {
          if (scrollPercent >= marker && !sentMarkers.includes(marker)) {
            sentMarkers.push(marker);
            window.dataLayer.push({
              event: "scroll_depth",
              percent: marker + "%",
            });
          }
        });
      },
      { passive: true },
    );

    // 5. Time Milestone Tracking
    const timers = [15, 30, 60]; // sekunde

    timers.forEach((seconds) => {
      setTimeout(() => {
        // Check if user is still on the page and not hidden (tab inactive)
        if (!document.hidden) {
          window.dataLayer.push({
            event: "time_milestone",
            seconds: seconds,
          });
        }
      }, seconds * 1000);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAnalytics);
  } else {
    initAnalytics();
  }
})();
